document.addEventListener('DOMContentLoaded', function() {
  initContactForm();
});

// Also try to init when window loads (fallback)
window.addEventListener('load', function() {
  initContactForm();
});

function initContactForm() {
  const contactForm = document.querySelector('form[action*="contact"]');
  if (!contactForm || contactForm.dataset.validated) return;
  
  // Mark as processed to avoid duplicate processing
  contactForm.dataset.validated = 'true';
  
  // Hide server errors immediately
  hideServerErrors();
  
  // Setup form validation
  setupContactFormValidation(contactForm);
}

function hideServerErrors() {
  const serverErrors = document.querySelectorAll('.form__message, ul');
  serverErrors.forEach(error => {
    if (error.textContent && (error.textContent.includes('Email is invalid') || 
        error.textContent.includes('adjust the following') ||
        error.textContent.includes('Please adjust'))) {
      error.style.display = 'none';
    }
  });
}

function setupContactFormValidation(contactForm) {
  // Find all inputs in the form first to see their actual names/ids
  const allInputs = contactForm.querySelectorAll('input, select, textarea');
  
  // Setup field validation for individual fields
  const inputs = {
    name: contactForm.querySelector('[name="contact[name]"]'),
    email: contactForm.querySelector('[name="contact[email]"]'),
    phone: contactForm.querySelector('[name="contact[phone]"]'),
    category: contactForm.querySelector('[name="contact[category]"]'),
    body: contactForm.querySelector('[name="contact[body]"]'),
    consent: contactForm.querySelector('[name="contact[consent]"]')
  };
  
  Object.values(inputs).forEach(input => {
    if (input) {
      setupFieldValidation(input);
    }
  });
  
  // Add form submission handler
  const originalSubmitHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (validateContactForm(contactForm)) {
      // Remove our handler and submit the original form
      contactForm.removeEventListener('submit', originalSubmitHandler, true);
      
      // Submit the original form with all its tokens
      setTimeout(() => {
        contactForm.submit();
      }, 10);
    }
    return false;
  };
  
  contactForm.addEventListener('submit', originalSubmitHandler, true);
  
  // Mark form as having validation ready
  contactForm.dataset.validated = 'true';
  
  // Test: Trigger validation on the name field after 3 seconds to debug
  setTimeout(() => {
    const nameInput = inputs.name;
    if (nameInput) {
      if (!nameInput.value.trim()) {
        showFieldError(nameInput, 'The field First Name is required.');
      }
    }
  }, 3000);
}

function setupFieldValidation(input) {
  const eventType = input.type === 'checkbox' ? 'change' : 'blur';
  input.addEventListener(eventType, () => {
    validateField(input);
  });
  input.addEventListener('input', () => clearFieldError(input));
}

function validateField(input) {
  switch(input.name) {
    case 'contact[name]':
      if (!input.value.trim()) {
        showFieldError(input, 'The field Name is required');
        return false;
      }
      break;
    case 'contact[email]':
      if (!input.value.trim()) {
        showFieldError(input, 'The field Email is required.');
        return false;
      }
      // More robust email validation that prevents:
      // - Local part starting/ending with dots
      // - Consecutive dots in local part or domain
      // - Domain labels starting/ending with hyphens
      if (!/^[a-z0-9_%+-]+(?:\.[a-z0-9_%+-]+)*@[a-z0-9]+(?:[a-z0-9-]*[a-z0-9])*(?:\.[a-z0-9]+(?:[a-z0-9-]*[a-z0-9])*)*\.[a-z]{2,4}$/i.test(input.value)) {
        showFieldError(input, 'Please enter a valid email address');
        return false;
      }
      break;
    case 'contact[category]':
      if (!input.value.trim()) {
        showFieldError(input, 'Please select a category');
        return false;
      }
      break;
    case 'contact[body]':
      if (!input.value.trim()) {
        showFieldError(input, 'The field Message is required');
        return false;
      }
      break;
    case 'contact[consent]':
      if (!input.checked) {
        showFieldError(input, 'The field Consent is required');
        return false;
      }
      break;
  }
  clearFieldError(input);
  return true;
}

function showFieldError(input, message) {
  // Add red styling to input - consistent with other forms
  if (input.classList.contains('ring-gray-300')) {
    input.classList.replace('ring-gray-300', 'ring-red-500');
    input.classList.replace('focus:ring-bbr-gold', 'focus:ring-red-500');
  }
  
  // Find the best place to insert the error message
  let targetContainer = null;
  let insertionPoint = null;
  
  // Try multiple strategies to find the right place
  
  // Strategy 1: Look for the field container with mb-3 class
  let fieldContainer = input.closest('.mb-3');
  if (fieldContainer) {
    targetContainer = fieldContainer;
    insertionPoint = 'append'; // Add to end of container
  }
  
  // Strategy 2: Look for any div container around the input
  if (!targetContainer) {
    fieldContainer = input.closest('div');
    if (fieldContainer) {
      targetContainer = fieldContainer;
      insertionPoint = 'append';
    }
  }
  
  // Strategy 3: Use the input's parent
  if (!targetContainer) {
    targetContainer = input.parentElement;
    insertionPoint = 'append';
  }
  
  // Create a safe ID by replacing problematic characters
  const safeId = input.id.replace(/[\[\]]/g, '_');
  const errorId = `${safeId}-error`;
  
  let errorElement = document.getElementById(errorId);
  
  if (!errorElement) {
    errorElement = document.createElement('p');
    errorElement.className = 'mt-2 text-sm text-red-600';
    errorElement.id = errorId;
    errorElement.style.display = 'block';
    errorElement.style.color = 'red';
    errorElement.style.fontSize = '14px';
    errorElement.style.marginTop = '8px';
    
    if (targetContainer) {
      if (insertionPoint === 'append') {
        targetContainer.appendChild(errorElement);
      } else {
        targetContainer.insertAdjacentElement('afterend', errorElement);
      }
    } else {
      // Fallback: insert after the input
      input.insertAdjacentElement('afterend', errorElement);
    }
  }
  
  errorElement.textContent = message;
  errorElement.style.display = 'block';
  
  // Hide all server errors
  const serverErrors = document.querySelectorAll('.form__message, ul');
  serverErrors.forEach(error => {
    if (error.textContent.includes('Email is invalid') || error.textContent.includes('adjust the following')) {
      error.style.display = 'none';
    }
  });
}

function clearFieldError(input) {
  // Reset input styling - consistent with other forms
  if (input.classList.contains('ring-red-500')) {
    input.classList.replace('ring-red-500', 'ring-gray-300');
    input.classList.replace('focus:ring-red-500', 'focus:ring-bbr-gold');
  }
  
  // Find and hide any error element for this input using safe ID
  const safeId = input.id.replace(/[\[\]]/g, '_');
  const errorId = `${safeId}-error`;
  const errorElement = document.getElementById(errorId);
  if (errorElement) {
    errorElement.style.display = 'none';
  }
}

function validateContactForm(contactForm) {
  let isValid = true;
  
  if (!contactForm) {
    contactForm = document.querySelector('form[action*="contact"]');
    if (!contactForm) return false;
  }
  
  const inputs = {
    name: contactForm.querySelector('[name="contact[name]"]'),
    email: contactForm.querySelector('[name="contact[email]"]'),
    category: contactForm.querySelector('[name="contact[category]"]'),
    body: contactForm.querySelector('[name="contact[body]"]'),
    consent: contactForm.querySelector('[name="contact[consent]"]')
  };
  
  // Validate required fields only
  const requiredFields = ['name', 'email', 'category', 'body', 'consent'];
  
  requiredFields.forEach(fieldName => {
    const input = inputs[fieldName];
    if (input && !validateField(input)) {
      isValid = false;
    }
  });
  
  return isValid;
}
